import React, { useEffect, useRef, useState } from "react";

// Animated count-up that triggers when scrolled into view.
export default function CountUp({ value = 0, decimals = 0, prefix = "", suffix = "", duration = 1400, className = "", testid }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const from = 0;
          const to = Number(value) || 0;
          const tick = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(from + (to - from) * eased);
            if (p < 1) requestAnimationFrame(tick);
            else setDisplay(to);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  const formatted =
    decimals > 0
      ? display.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
      : Math.round(display).toLocaleString();

  return (
    <span ref={ref} className={className} data-testid={testid}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
